var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageCategoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.24997 14.9997H14.7497C15.4392 14.9997 15.9997 14.4392 15.9997 13.7497V3.24997C15.9997 2.56104 15.4392 2 14.7497 2H1.24997C0.561045 2 0 2.56104 0 3.24997V11.773V11.773V13.7497C0 14.4392 0.561045 14.9997 1.24997 14.9997ZM0.999978 3.24997V10.671L4.98277 7.18602C5.54124 6.69709 6.3602 6.68703 6.93073 7.16248L10.2191 9.90273L11.1537 9.15492C11.7061 8.71341 12.4766 8.71441 13.0276 9.15536L14.9997 10.7329V3.24997C14.9997 3.11203 14.8872 2.99998 14.7497 2.99998H1.24997C1.11203 2.99998 0.999978 3.11203 0.999978 3.24997ZM14.9997 12.0139V13.7497C14.9997 13.8872 14.8872 13.9997 14.7497 13.9997H1.24997C1.11203 13.9997 0.999978 13.8872 0.999978 13.7497V11.9998L5.64125 7.93862C5.8273 7.77556 6.10028 7.77255 6.29023 7.93058L9.42194 10.5406L8.36924 11.3829C8.15373 11.5554 8.11869 11.8699 8.29123 12.0859C8.4632 12.3009 8.77826 12.3369 8.99422 12.1639L11.7782 9.93591C11.9632 9.78837 12.2192 9.78837 12.4027 9.93591L14.9997 12.0139ZM10 5.99996C10 7.10293 10.897 7.99991 12 7.99991C13.1029 7.99991 13.9999 7.10293 13.9999 5.99996C13.9999 4.89698 13.1029 4 12 4C10.897 4 10 4.89698 10 5.99996ZM11 5.99996C11 5.44851 11.4485 4.99998 12 4.99998C12.5514 4.99998 12.9999 5.44851 12.9999 5.99996C12.9999 6.5514 12.5514 6.99993 12 6.99993C11.4485 6.99993 11 6.5514 11 5.99996Z",
    fill: "#6D7382"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageCategoryIcon);
export default __webpack_public_path__ + "static/media/image-category-icon.90b5a638eeebc52a5d80b0af7d51f59f.svg";
export { ForwardRef as ReactComponent };